module.exports = __webpack_public_path__ + "img/tpc-5.e778bfea.jpg";